import styled from 'styled-components'
import { em } from 'polished'

import { Text } from 'shared/Typography'

const BG_COLOR = '#42302e'
const ACCENT_COLOR = '#bee6ff'
const IMAGE_PATH_DESKTOP = '/static/images/banner-bundle/photo.png'
const IMAGE_PATH_MOBILE = '/static/images/banner-bundle/photo-mobile.png'

export const Root = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: ${BG_COLOR};
  overflow: hidden;
`

/**
 * Фото-композиция (рука с клошем над столиком + две коробки).
 * Mobile: снизу на всю ширину. Tablet: справа. Desktop: справа на всю высоту.
 */
export const Photo = styled.div`
  position: absolute;
  top: ${em(218)};
  left: 50%;
  width: min(100vw, ${em(430)});
  height: min(100vw, ${em(430)});
  transform: translateX(-50%);
  background-image: url('${IMAGE_PATH_MOBILE}');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: right bottom;

  ${p => p.theme.mq.upThreshold(431)} {
    top: clamp(${em(218)}, 50vw, ${em(300)});
    left: auto;
    right: 0;
    width: min(100vw, ${em(617)});
    height: min(100vw, ${em(430)});
    transform: none;
    -webkit-mask-image: linear-gradient(to bottom, transparent 0, #000 ${em(24)});
    mask-image: linear-gradient(to bottom, transparent 0, #000 ${em(24)});
  }

  ${p => p.theme.mq.upMd} {
    top: ${em(223)};
    left: auto;
    right: 0;
    width: ${em(617)};
    height: ${em(617)};
    transform: none;
    -webkit-mask-image: none;
    mask-image: none;
  }

  ${p => p.theme.mq.upLg} {
    top: 0;
    right: 0;
    bottom: auto;
    width: ${em(720)};
    height: 100%;
    background-image: url('${IMAGE_PATH_DESKTOP}');
    background-size: cover;
    background-position: bottom right;
  }
`

export const Content = styled.div`
  position: relative;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
  padding: ${em(46)} ${em(20)} 0;

  ${p => p.theme.mq.upMd} {
    padding: ${em(60)} ${em(20)} 0;
  }

  ${p => p.theme.mq.upLg} {
    padding: ${em(100)} 0 0 ${em(80)};
  }
`

export const Title = styled(Text)`
  font-family: ${p => p.theme.typography.mediumFont};
  color: #fff;
  max-width: ${em(320, 30)};

  & span {
    color: ${ACCENT_COLOR};
  }

  ${p => p.theme.mq.upMd} {
    max-width: ${em(728, 50)};
  }

  ${p => p.theme.mq.upLg} {
    max-width: ${em(455, 65)};
  }
`

export const Description = styled(Text)`
  font-family: ${p => p.theme.typography.baseFont};
  margin-top: ${em(10)};
  color: #fff;
  max-width: ${em(320, 16)};

  & span {
    font-family: ${p => p.theme.typography.mediumFont};
  }

  & .bundle-desc-break-md {
    display: block;
  }

  & .bundle-desc-break-lg {
    display: none;
  }

  ${p => p.theme.mq.upMd} {
    margin-top: ${em(18)};
    max-width: ${em(355, 18)};
  }

  ${p => p.theme.mq.upLg} {
    max-width: ${em(455, 18)};

    & .bundle-desc-break-md {
      display: none;
    }

    & .bundle-desc-break-lg {
      display: block;
    }
  }
`

export const PriceRow = styled.div`
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: ${em(20)};
  padding: ${em(16)} ${em(20)} 0;

  ${p => p.theme.mq.upMd} {
    padding: ${em(63)} ${em(20)} 0;
  }

  ${p => p.theme.mq.upLg} {
    padding: 0;
    position: absolute;
    left: ${em(80)};
    top: ${em(488)};
  }
`

export const Price = styled(Text)`
  font-family: ${p => p.theme.typography.mediumFont};
  color: #fff;
  white-space: nowrap;
`
